import { pricingContainer, pricingSection, PricingHeading } from './Shared'
export default function PricingAddons({ data }) {
    return (
        <section className={pricingSection}>
            <div className={pricingContainer}>
                <PricingHeading {...data} />
                <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
                    {data.items.map((item) => (
                        <article
                            key={item.name}
                            className="rounded-2xl border border-black/10 bg-white p-6 shadow-sm">
                            <h3 className="mb-1.5 text-[15px] font-bold">
                                {item.name}
                            </h3>
                            <p
                                className={`mb-2 font-extrabold ${
                                    item.pending
                                        ? 'text-sm text-olm-gray'
                                        : 'text-xl text-secondary'
                                }`}>
                                {item.price}
                                <span className="text-xs font-semibold text-olm-gray">
                                    {' '}
                                    {item.suffix}
                                </span>
                            </p>
                            <p className="text-[13px] leading-relaxed text-olm-gray">
                                {item.description}
                            </p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    )
}
